export const GROUP_WITH_STANDALONE_FILTERS = 'group_with_standalone_filters';
